module.exports = __webpack_public_path__ + "img/qx.0a68a9ef.png";